import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { NavLink, useHistory } from 'react-router-dom';
import useStyles from './styles';
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../../firebase-config";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright '}
            <Link color="inherit" href="https://LogicLovers.ru">
                LogicLovers.ru
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const SignUp = () => {
    const classes = useStyles();
    const [errorMessage, setErrorMessage] = useState('');
    const history = useHistory();

    const handleGoogleSignUp = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            // Проверка на новую регистрацию
            if(user.metadata.creationTime === user.metadata.lastSignInTime) {
                alert('Добро пожаловать! Регистрация прошла успешно!');
            }

            localStorage.setItem('token', await user.getIdToken());
            localStorage.setItem('username', user.displayName || '');
            history.push('/');
        } catch (error) {
            console.error('Ошибка регистрации:', error);
            setErrorMessage('Ошибка регистрации через Google');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <NavLink to={'/'}>
                    <Button style={{ marginTop: 10, marginRight: 100 }}>
                        Назад
                    </Button>
                </NavLink>
            </div>
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Регистрация
                </Typography>
                <div className={classes.form}>
                    {errorMessage && (
                        <Typography color="error">
                            {errorMessage}
                        </Typography>
                    )}
                    <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        className={classes.submit}
                        onClick={handleGoogleSignUp}
                    >
                        Зарегистрироваться через Google
                    </Button>
                </div>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
};

export default SignUp;



// const SignUp = () => {
//     const classes = useStyles();
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [username, setUsername] = useState('');
//     const [emailError, setEmailError] = useState('');
//     const [usernameError, setUsernameError] = useState('');
//     const [errorMessage, setErrorMessage] = useState('');
//     const history = useHistory();
//
//     const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const newEmail = e.target.value;
//         setEmail(newEmail);
//
//         if (newEmail.length > 50) {
//             setEmailError('Максимальная длина email - 50 символов');
//         } else if (!validator.isEmail(newEmail)) {
//             setEmailError('Введите корректный адрес электронной почты');
//         } else {
//             setEmailError('');
//         }
//     };
//
//     const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const newUsername = e.target.value;
//         setUsername(newUsername);
//
//         if (newUsername.length > 50) {
//             setUsernameError('Максимальная длина имени пользователя - 50 символов');
//         } else {
//             setUsernameError('');
//         }
//     };
//
//     const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
//         event.preventDefault();
//
//         if (emailError || usernameError) {
//             setErrorMessage('Пожалуйста, исправьте ошибки в форме');
//             return;
//         }
//
//         try {
//             let response = await SecurityAPI.signup(username, email, password);
//
//             if (response === "User created") {
//                 alert('Пользователь зарегистрирован');
//                 history.push('/');
//             }
//         } catch (error: any) {
//             if (error.response && error.response.status === 400) {
//                 setErrorMessage(error.response.data.message || 'Выбери другое имя или почту');
//             } else {
//                 setErrorMessage('Ошибка сети или сервера');
//             }
//         }
//     };
//
//     return (
//         <Container component="main" maxWidth="xs">
//             <CssBaseline />
//             <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                 <NavLink to={'/'}>
//                     <Button style={{ marginTop: 10, marginRight: 100 }}>
//                         Назад
//                     </Button>
//                 </NavLink>
//             </div>
//             <div className={classes.paper}>
//                 <Avatar className={classes.avatar}>
//                     <LockOutlinedIcon />
//                 </Avatar>
//                 <Typography component="h1" variant="h5">
//                     Регистрация
//                 </Typography>
//                 <form className={classes.form} noValidate onSubmit={handleSubmit}>
//                     {errorMessage && (
//                         <Typography color="error" style={{ marginBottom: '1rem' }}>
//                             {errorMessage}
//                         </Typography>
//                     )}
//                     <TextField
//                         variant="outlined"
//                         margin="normal"
//                         required
//                         fullWidth
//                         id="email"
//                         label="Электронная почта"
//                         name="email"
//                         autoComplete="email"
//                         autoFocus
//                         value={email}
//                         onChange={handleEmailChange}
//                         error={!!emailError}
//                         helperText={emailError}
//                         inputProps={{ maxLength: 50 }}
//                     />
//                     <TextField
//                         variant="outlined"
//                         margin="normal"
//                         required
//                         fullWidth
//                         name="username"
//                         label="Имя пользователя"
//                         id="username"
//                         autoComplete="username"
//                         value={username}
//                         onChange={handleUsernameChange}
//                         error={!!usernameError}
//                         helperText={usernameError}
//                         inputProps={{ maxLength: 50 }}
//                     />
//                     <TextField
//                         variant="outlined"
//                         margin="normal"
//                         required
//                         fullWidth
//                         name="password"
//                         label="Пароль"
//                         type="password"
//                         id="password"
//                         autoComplete="current-password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                     />
//                     <Button
//                         type="submit"
//                         fullWidth
//                         variant="contained"
//                         color="primary"
//                         className={classes.submit}
//                     >
//                         Зарегистрироваться
//                     </Button>
//                 </form>
//             </div>
//             <Box mt={8}>
//                 <Copyright />
//             </Box>
//         </Container>
//     );
// };
// SingUp/index.tsx
